
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fansinvest",
      function () {
        return require("private-next-pages/fansinvest/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fansinvest"])
      });
    }
  